var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-footer-indicators__mouse"},[_c('div',{ref:"scrollAnimation",style:(_vm.animationContainerStyles),attrs:{"id":"scroll-animation"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }